'use client';

import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Liquidation from './components/Liquidation/Liquidation';
import Stepper from '../../components/stepper/Stepper';
import { enumForm } from '../../enum/form';
import Commodity from './components/Commodity/Commodity';
import Compliance from './components/Compliance/Compliance';
import Credit from './components/Credit/Credit';
import Currency from './components/Currency/Currency';
import Disaster from './components/Disaster/Disaster';
import Funding from './components/Funding/Funding';
import Interest from './components/Interest/Interest';
import Legal from './components/Legal/Legal';
import Operational from './components/Operational/Operational';
import useFormStore from '../../store/FormStore';
import useStepperStore from '../../store/StepperStore';

const HomePage = () => {
  const { data } = useFormStore();
  const { currentItem } = useStepperStore();
  const formMethods = useForm({ defaultValues: data });

  return (
    <FormProvider {...formMethods}>
      <Stepper>
        {currentItem.id == 1 && <Liquidation />}
        {currentItem.id == 2 && <Funding />}
        {currentItem.id == 3 && <Credit />}
        {currentItem.id == 4 && <Commodity />}
        {currentItem.id == 5 && <Currency />}
        {currentItem.id == 6 && <Interest />}
        {currentItem.id == 7 && <Operational />}
        {currentItem.id == 8 && <Disaster />}
        {currentItem.id == 9 && <Compliance />}
        {currentItem.id == 10 && <Legal />}
      </Stepper>
    </FormProvider>
  );
};

export default HomePage;
